module.exports = __webpack_public_path__ + "static/img/13.11c7483.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/1/1/3/zh/13.png
// module id = yGlx
// module chunks = 0